import { render, staticRenderFns } from "./ThirdComp.vue?vue&type=template&id=93a55e8a&scoped=true&"
import script from "./ThirdComp.vue?vue&type=script&lang=js&"
export * from "./ThirdComp.vue?vue&type=script&lang=js&"
import style0 from "./ThirdComp.vue?vue&type=style&index=0&id=93a55e8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a55e8a",
  null
  
)

export default component.exports